import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=4d2c5cae&scoped=true"
import script from "./EditPage.vue?vue&type=script&lang=js"
export * from "./EditPage.vue?vue&type=script&lang=js"
import style0 from "./EditPage.vue?vue&type=style&index=0&id=4d2c5cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c5cae",
  null
  
)

export default component.exports